<template>
  <div id="measure-edit">
    <v-container>
      <v-card width="800" elevation="1" outlined tile>
        <v-card-title class="headline my-3">計測記録の設定</v-card-title>
        <v-card-text>
          <div class="form-control mb-6">
            <h5 class="text-subtitle-1 mb-3">計測名称</h5>
            <v-text-field
              outlined
              solo
              single-line
              style="max-width= 450px"
              flat
              dense
              hide-details
              v-model="measure.name"
            ></v-text-field>
          </div>

          <h5 class="text-subtitle-1 my-3">説明</h5>
          <v-textarea
            outlined
            solo
            flat
            name="input-7-4"
            v-model="measure.description"
          ></v-textarea>

          <template v-if="admin">
            <v-row>
              <v-col>
                <div>現場グループ</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  :items="site_groups"
                  item-text="name"
                  item-value="id"
                  style="max-width: 450px;"
                  v-model="measure.site_group_id"
                ></v-select>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="0" tile class="px-5" @click="$router.go(-1)">
            <span class="font-weight-bold">キャンセル</span></v-btn
          >
          <v-btn elevation="0" tile color="success" class="px-5" @click="edit">
            <span class="font-weight-bold">設定の更新</span></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import api from "@/api";
import { mapGetters } from "vuex";

export default {
  name: "measure-edit",
  data() {
    return {
      measure: null,
      site_groups: [],
    };
  },
  async created() {
    this.measure = Object.assign(
      {},
      this.$store
        .$db()
        .model("measures")
        .query()
        .whereId(+this.$route.params.id)
        .withAll()
        .first()
    );

    this.site_groups = await api.site_groups.list();
  },
  computed: {
    ...mapGetters("user", { admin: "isAdmin" }),
  },
  methods: {
    edit() {
      const measureId = this.$route.params.id;
      const params = {
        name: this.measure.name,
        description: this.measure.description,
        site_group_id: this.measure.site_group_id,
      };

      api.measures.update(measureId, params).then((data) => {
        this.$store
          .$db()
          .model("measures")
          .insert({ data });
        this.$router.push({ name: "MeasureList" });
      });
    },
  },
};
</script>
